export default __webpack_public_path__ + "assets/52b945cdbf344f62b36eb5bcb6bcfebe.svg";